var app = new Vue({
    delimiters: ['[[', ']]'],
    el: '#app',
    data: {
        siteKey:'6LdqfqwZAAAAAAxTheTddeCGxX71wgF4UPMc45Qe',
    },
    beforeMounted(){

    },
    mounted(){
        let recaptchaScript = document.createElement('script')
        recaptchaScript.async = true
        recaptchaScript.defer = true
        recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit'
        document.head.appendChild(recaptchaScript);
    },
    methods: {
        // verifyCallback: function(response){
        //     this.$refs['download-app'].verifyCallback(response);
        // },
        verifyCallbackEnterprise: function(response){
            this.$refs['app-container'].$refs['contact-enterprise'].verifyCallback(response);
        },
        verifyCallbackContactUs: function(response){
            this.$refs['app-container'].$refs['contact-us'].verifyCallback(response);
        },
        verifyCallbackContactPartner: function(response){
            this.$refs['app-container'].$refs['contact-partner'].verifyCallback(response);
        },
        verifyCallbackContactBetaTester: function(response){
            this.$refs['app-container'].$refs['contact-beta-tester'].verifyCallback(response);
        },
    },
});

function onloadCallback() {
    var siteKey = app.$data.siteKey;
    // grecaptcha.render('download-app', {
    //     'sitekey' : siteKey,
    //     'callback' : verifyCallback,
    // });
    grecaptcha.render('contact-enterprise', {
        'sitekey' : siteKey,
        'callback' : verifyCallbackEnterprise,
    });
    grecaptcha.render('contact-us', {
        'sitekey' : siteKey,
        'callback' : verifyCallbackContactUs,
    });
    grecaptcha.render('contact-partner', {
        'sitekey' : siteKey,
        'callback' : verifyCallbackContactPartner,
    });
    grecaptcha.render('contact-beta-tester', {
        'sitekey' : siteKey,
        'callback' : verifyCallbackContactBetaTester,
    });
}

window.onloadCallback = onloadCallback;

var verifyCallback = function(response) {
    app.verifyCallback(response);
};

var verifyCallbackEnterprise = function(response) {
    app.verifyCallbackEnterprise(response);
};

var verifyCallbackContactUs = function(response) {
    app.verifyCallbackContactUs(response);
};

var verifyCallbackContactPartner = function(response) {
    app.verifyCallbackContactPartner(response);
};

var verifyCallbackContactBetaTester = function(response) {
    app.verifyCallbackContactBetaTester(response);
};